import React from "react";

import styles from "./TabChooseButton.module.css"
import {Link} from "react-router-dom";

interface TabChooseButtonProps {
    onClick?: () => void
    imageSrc: string
    text: string
    isActive: boolean
    to?: string
    replace?: boolean
}


export const TabChooseButton: React.FC<TabChooseButtonProps> = ({onClick, imageSrc, text, isActive, to, replace}) => {
    const content = <>
        <img src={imageSrc} alt="icon"/>
        <span className={styles.tabText}>{text}</span>
    </>;

    if (to) {
        return <Link
            className={`${styles.tab} ${isActive ? styles.tabActive : ""}`}
            to={to}
            replace={replace}
            onClick={onClick}
        >
            {content}
        </Link>
    }

    return <div className={`${styles.tab} ${isActive ? styles.tabActive : ""}`} onClick={onClick}>
        {content}
    </div>
}
